import React from "react";
import { Box, IconButton, Modal, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IoCloseCircle } from "react-icons/io5";
import LoginForm from "../Login/LoginForm";
import ic_timer from "../../images/icon/ic-countdown-timer.svg";

// estilos secciones del componente
const ModalContent = styled(Modal)(() => ({
  zIndex: 1000,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const ModalBody = styled(Box)(() => ({
  position: "relative",
  width: "90%",
  maxWidth: "600px",
  backgroundColor: "#FFFFFF",
  padding: "2rem 1rem",
  borderRadius: "10px",
  "@media(min-width:500px)": {
    width: "80%",
  },
}));

const ModalHeader = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const Icon = styled("img")(() => ({
  maxWidth: "40px",
  marginBottom: "2rem",
}));

const Text = styled("p")(() => ({
  fontFamily: "Patua One",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "18px",
  textAlign: "center",
  marginBottom: 0,
  "@media(min-width: 500px)": {
    fontSize: "18px",
    lineHeight: "22px",
  },
}));

// componentes Locales
const CloseButton = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: 5,
        right: 5,
      }}
    >
      <IoCloseCircle />
    </IconButton>
  );
};

// componente principal
const ExpiredSessionLogin = ({ open, onClose, showCloseModalLogin = true, logout = () => {} }) => {
  const { t } = useTranslation();

  const handleCloseModalLogin = () => {
    if (showCloseModalLogin) {
      onClose();
    }

    // logout();
  };

  return (
    <ModalContent
      id="modalLogin"
      open={open}
      onClose={handleCloseModalLogin}
      aria-labelledby="signin-modal-title"
      aria-describedby="signin-modal-description"
    >
      <ModalBody boxShadow={24}>
        {showCloseModalLogin && <CloseButton onClick={handleCloseModalLogin} />}

        <ModalHeader>
          <Icon src={ic_timer} alt="icono reloj" />
          <Text>{t("session_expired.text1")}</Text>
          <Text>{t("session_expired.text2")}</Text>
        </ModalHeader>

        <LoginForm source="modal" onCloseLogin={onClose} showSectionRegister={false} onOpenRegister={() => {}} onCloseRegister={() => {}} />
      </ModalBody>
    </ModalContent>
  );
};

export default ExpiredSessionLogin;
